import * as AuthC from '../auth/AuthCognito';


export const fetchAsJson = (url) => {
    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
    .then(response => {
        if (response.ok) {
            return response;
        } else {
            var error = new Error('Error ' + response.status + ': ' + response.statusText);
            error.response = response;
            throw error;
        }
    },
        error => {
            var errmess = new Error(error.message);
            throw errmess;
        })
    .then(response => response.json());
}


export const postAsJson = (url, bodyContent) => {
    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(url.href, {
        method: "POST",
        mode: 'cors',
        body: JSON.stringify(bodyContent),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
    .then(response => {
        if (response.ok) {
            return response;
        } else {
            var error = new Error('Error ' + response.status + ': ' + response.statusText);
            error.response = response;
            throw error;
        }
    },
        error => {
            var errmess = new Error(error.message);
            throw errmess;
        })
    .then(response => response.json());
}


export const fetchAsDocument = (url) => {
    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            'Authorization': bearer,
            'Accept': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then((response) => response.blob());
}


export const fetchAsImage = (url) => {
    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            'Authorization': bearer,
            'Accept': 'image/*'
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then((response) => response.blob());
}


export const fetchAsPdf = (url) => {
    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            'Authorization': bearer,
            'Content-Type': 'application/pdf',
            'Accept': 'application/pdf'
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then((response) => response.blob());
}

